import React, { useEffect, useState } from "react";
import categoryAPI from "../../api/categoryApi";
import { useParams } from "react-router-dom";
import Breadcrump from "../../components/Breadcrump";
import SEO from "../../components/SEO";
import CategoryCard from "../categories/Card";
import ProductCard from "../products/Card";

function DetailPage() {
  const { "*": slug } = useParams();
  const [item, setItem] = useState({});
  const [subcategories, setSubCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [metaData, setMetaData] = useState({});

  const fetchCategoryDetail = async () => {
    try {
      const res = await categoryAPI.details(slug);

      if (res.code === 200) {
        const result = res.data;

        setItem(result?.category);
        setSubCategories(result?.subcategories);
        setProducts(result?.products);
        setMetaData(result?.category?.meta);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    } finally {
    }
  };

  useEffect(() => {
    fetchCategoryDetail();
  }, [slug]);

  return (
    <>
      <Breadcrump title={item?.name} />

      <SEO meta={metaData} />

      {subcategories && subcategories.length > 0 && (
        <section className="s-term-user flat-spacing-25">
          <div className="container">
            <div className="row">
              {subcategories.map((subcategory, index) => (
                <div className="col-md-2" key={index}>
                  <CategoryCard item={subcategory} />
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {products && products.length > 0 && (
        <div className="flat-spacing-2 custom-catg-pag-sec " >
          <div className="container">
            <div className="flat-animate-tab flat-controltab-nav">
              <div className="flat-title text-start">
                <h4>Our Products</h4>
              </div>
              <div className="row">
                {products.map((product, index) => (
                  <div
                    className="col-lg-3 col-sm-6 col-xs-6 mb-2"
                    key={[product._id || index]}
                  >
                    <ProductCard item={product} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DetailPage;
